import Chip from "@mui/material/Chip";

import { getScoutTierChipSx, SCOUT_TIER_CHIP_STYLES, type ScoutTier } from "./scoutTierChipStyles";

export type { ScoutTier } from "./scoutTierChipStyles";

type ScoutTierChipProps = {
  tier: ScoutTier;
};

/**
 * Visual distinction between Scout tiers. Pro is brand teal (sapphire); Regulatory
 * Advisor is brand pumpkin. Outlined + soft fill matches the chip design-system
 * light-on-the-eyes pattern, using brand colors rather than MUI semantic roles.
 */
export function ScoutTierChip({ tier }: ScoutTierChipProps) {
  const { label } = SCOUT_TIER_CHIP_STYLES[tier];

  return <Chip size="small" label={label} variant="outlined" sx={getScoutTierChipSx(tier)} />;
}
